<app-popover>
  <div class="grid h-auto px-2">
    <button
      *ngIf="
        data.assessment.aplicacoes[0]?.modo_aplicacao !== assessmentApplicationMode.Online &&
        (data.assessment.aplicacoes[0]?.previewer || canPreview)
      "
      app-outline-button
      (click)="onAssessmentsPrintSettingsComponent()"
      class="group my-1 h-9 w-full min-w-[140px] !justify-start border-none bg-black/5 text-left text-black/80 hover:bg-base-status-info hover:font-semibold hover:text-white"
      app-tooltip
    >
      <svg-icon
        class="mr-2 h-6 w-6 text-base-status-info group-hover:text-white"
        src="assets/icons/icon-print.svg"
      ></svg-icon>
      <span class="group-hover:text-theme-contrast md:inline-block" translate> gestor-avaliacoes.prova </span>
    </button>

    <button
      app-outline-button
      *ngIf="isEntity && data.assessment.aplicacoes[0]?.modo_aplicacao !== assessmentApplicationMode.Online"
      (click)="onCreateResponseCard()"
      class="group my-1 h-9 w-full min-w-[140px] !justify-start border-none bg-black/5 text-left text-black/80 hover:bg-theme-500 hover:font-semibold hover:text-white"
    >
      <svg-icon
        class="mr-2 h-5 w-5 text-theme-500 group-hover:text-white"
        src="assets/icons/icon-clipboard-check.svg"
      ></svg-icon>
      <span class="group-hover:text-theme-contrast md:inline-block" translate> gestor-avaliacoes.cartao-resp </span>
    </button>
  </div>
</app-popover>
